import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextH1Props {
    children: ReactNode
    className?: string
}

const TextH1 = ({ children, className }: TextH1Props) => {
    return <h1 className={[css.h1, className].filter(Boolean).join(' ')}>{children}</h1>
}

export default TextH1
